import ChatFeedback from './ChatFeedback';
import type { ComponentSelector } from '../types';

export type FromResponseProps = {
    setComponent: (val: ComponentSelector) => void;
};

export default function FromResponse({ setComponent }: FromResponseProps) {
    return <ChatFeedback onNavigateBack={() => setComponent('front')} type='confirmation' />;
}
